import { buildEstimatePdfDocumentDefinition } from "./buildEstimatePdfDocument";
import { exportReportPdf } from "../shared/pdfMakeClient";
import { buildEstimatePdfFilename } from "../shared/reportPdfFilenames";
import { prepareReportPdfBranding } from "../../helpers/prepareReportPdfBranding";

export async function downloadEstimateReportPdf(reportModel, { branding } = {}) {
  if (!reportModel) {
    throw new Error("Report model is required");
  }

  const { branding: resolvedBranding, logoDataUrl } =
    await prepareReportPdfBranding(branding);

  const docDefinition = buildEstimatePdfDocumentDefinition(reportModel, {
    logoDataUrl,
    branding: resolvedBranding,
  });

  const filename = buildEstimatePdfFilename(reportModel);

  await exportReportPdf(
    docDefinition,
    filename,
    `Estimate Report — ${reportModel.header?.estimateNumber || "Report"}`,
  );
}
